<div (click)="focusInput()">
  <ng-content select="[before]"></ng-content>
</div>
<div>
  <div measurer #measurer></div>

  <input [disabled]="disabled" type="text"
         (keyup)="onkeyup($event)"
         (keydown)="onkeydown($event)"
         (change)="$event.stopPropagation()"
         (blur)="onblur($event)"
         (focus)="onfocus($event)"
         value="{{text}}"
         placeholder="{{placeHolder | lang}}" />

  <small *ngIf="hint">{{hintText | lang}}</small>
</div>
<div (click)="focusInput()">
  <ng-content select="[after]"></ng-content>
</div>
